import React, { useEffect, useState } from 'react';
import Table from '@digital-hig/mui/dist/Table';
// eslint-disable-next-line import/no-extraneous-dependencies
import TableBody from '@mui/material/TableBody';
// eslint-disable-next-line import/no-extraneous-dependencies
import TableCell from '@mui/material/TableCell';
import TableRow from '@digital-hig/mui/dist/TableRow';
import Typography from '@digital-hig/mui/dist/Typography';
// eslint-disable-next-line import/no-extraneous-dependencies
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import Grid from '@mui/material/Grid';
import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import TextLink from '@mui/material/Link';
// eslint-disable-next-line import/no-extraneous-dependencies

import {
  LEARNING_MODE_COURSEWARE, LRS_VERB_COMPLETED, LRS_VERB_STARTED, styleVariables,
} from '../common/constants';
import { LRSHasVerbRecordForID } from '../common/utilities';
import StatusPill from '../common/statusPill';
import { generateCourseDataAnalyticsString, triggerManualLinkClick } from '../common/analyticsApi';
import TrialAcknowledgementPanel from './trialAcknowledgementPanel';

const RecentItem = ({ recent, env, learningRecords }) => {
  const [recordData, setRecordData] = useState();

  useEffect(() => {
    recent.data.then((res) => {
      let displayType = '';
      let displayEffort = '';
      let showStatus = false;

      switch (recent?.statements[0].objectType.toLowerCase().replace(' ', '')) {
      case 'module':

        if (res.learningMode === LEARNING_MODE_COURSEWARE) {
          displayType = <span>Module</span>;
          showStatus = true;
        } else {
          displayType = <span>Tutorial</span>;
        }
        break;

      case 'course':
        if (res.learningMode === LEARNING_MODE_COURSEWARE) {
          displayType = <span>Course</span>;
          showStatus = true;
        } else {
          displayType = <span>Curated List</span>;
          displayEffort = res?.tutorials?.length ? (
            <span>
              {res.tutorials.length}
              {' '}
              tutorials
            </span>
          ) : undefined;
        }
        break;
      case 'learningpathway':
      case 'collection':
        displayType = <span>Collection</span>;
        displayEffort = res.itemCount ? (
          <span>
            {res.itemCount}
            {' '}
            items
          </span>
        ) : undefined;
        break;

      default:
        // eslint-disable-next-line no-param-reassign
        res.err = 'Bad content type';
        break;
      }
      setRecordData({
        ...res, displayType, displayEffort, showStatus,
      });
    });
  }, []);

  if (recordData) {
    if (!recordData.err && recordData.stillOffered) {
      const metaData = [];
      if (recordData.showStatus) {
        if (LRSHasVerbRecordForID({
          learningRecords, id: recordData.id, verb: LRS_VERB_COMPLETED, env,
        })) {
          metaData.push(<StatusPill isComplete positioned={false} />);
        } else if (recordData?.learningMode === LEARNING_MODE_COURSEWARE && LRSHasVerbRecordForID({
          learningRecords, id: recordData.id, verb: LRS_VERB_STARTED, env,
        })) {
          metaData.push(<StatusPill isStarted positioned={false} />);
        }
      }
      metaData.push(recordData.displayType);
      if (recordData.displayEffort) {
        metaData.push(recordData.displayEffort);
      }

      return (
        <TableRow>
          <TableCell className="recentCell">
            <Typography variant="headline-smaller">
              <TextLink
                component={Link}
                to={recordData.uri}
                onClick={() => {
                  triggerManualLinkClick({ linkTitle: `homepage recent activity:title:${generateCourseDataAnalyticsString({ data: recordData, learningRecords, env })}` });
                }}
              >
                {recordData.title}
              </TextLink>
            </Typography>

            <Typography variant="short-copy-small" className="recentMeta">{metaData}</Typography>

          </TableCell>
        </TableRow>
      );
    }
    return <></>;
  }

  return <Skeleton />;
};

RecentItem.propTypes = {
  recent: PropTypes.shape({
    statements: PropTypes.arrayOf(PropTypes.shape({
      objectType: PropTypes.string,
    })),
    data: PropTypes.shape({
      then: PropTypes.func,
    }),
  }).isRequired,
  env: PropTypes.string.isRequired,
  learningRecords: PropTypes.shape({}).isRequired,
};

const IndexRecentActivity = ({
  env, learningRecords, recentData, trialEntitlements, showBuyNowTrialPanel,
}) => (
  <RootElement id="recentActivity">
    <Grid container>
      <Grid item lg={12} xs={12}>
        <Typography variant="headline-medium">
          Your recent activity
        </Typography>
        <Grid item className="recent-activity-trial">
          <Grid lg={8} xs={12}>
            <Table bordered>
              <TableBody>
                {recentData.map((record) => <RecentItem recent={record} env={env} learningRecords={learningRecords} />)}
              </TableBody>
            </Table>
            <Button component={Link} to="/dashboard" variant="outlined" className="seeAll" onClick={() => { triggerManualLinkClick({ linkTitle: 'See all activity on My Dashboard' }); }}>See all activity on My Dashboard</Button>
          </Grid>
          <Grid lg={4} xs={12}>
            {recentData && showBuyNowTrialPanel && trialEntitlements && trialEntitlements.length ? <TrialAcknowledgementPanel recentData={recentData} trialEntitlements={trialEntitlements} /> : null}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </RootElement>
);

const RootElement = styled.div`
.MuiGrid-root.MuiGrid-item{
  padding-left: 0;
}
  
  .recentCell {
    text-align: left !important;
    padding-left: 16px !important;
    a {
      text-align: left !important;
    }
  }

  .recent-activity-trial {
    display: flex;
    flex-direction: row;
    gap: 24px;
  }
  
  .seeAll {
    margin-top: 14px;
  }
  
  .recentMeta {
    padding-top: 10px;
    display:flex;
    align-items: center;
    color: ${styleVariables.inkOnBackground60};
    
    *:not(:first-child) {
      padding-left: 12px;      
      margin-left: 12px;
      border-left: 1px solid ${styleVariables.inkOnBackground60};
    }
  }

   @media only screen and (max-width:560px){
    .recent-activity-trial {
      display: flex;
      flex-direction: column;
      gap: 32px;
      }
   }
`;

IndexRecentActivity.propTypes = {
  recentData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  env: PropTypes.string.isRequired,
  learningRecords: PropTypes.shape({}).isRequired,
  trialEntitlements: PropTypes.oneOfType([PropTypes.array]),
  showBuyNowTrialPanel: PropTypes.bool.isRequired,
};

IndexRecentActivity.defaultProps = {
  trialEntitlements: [],
};

export default React.memo(IndexRecentActivity);
